import React from "react";
import InnerWhatsAppList from "../../whatsapp/InnerWhatsAppList";

class WhatsAppTab extends React.Component {
  render() {
    const tab = this.props.activeTab;
    return (
      <div
        className={`tab-pane fade ${tab === "whatsapp" ? "show active in" : ""
          }`}>
        <div className="row">
          <div className="col-md-12">
            <InnerWhatsAppList
              id={this.props.id}
              type={this.props.type}
              {...this.props}
              reload={this.props.reload}
            />
          </div>
        </div>
      </div>
    );
  }
}
export default WhatsAppTab;
